import subscribeMutations from '@/settings/vuex/mutations/subscribe';

export default {
  ...subscribeMutations,
};
